import React, { useState, useEffect, useMemo } from "react";
import {
  Grid,
  Box,
  Typography,
  
  IconButton,
  Tooltip,
  Button,
} from "@mui/material";
import ModalLyt from "../../../components/Layouts/ModalLyt/ModalLyt";
import KrDetails from "../LComponents/KrDetails/KrDetails";
import { DataGrid, GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import KrActions from "../LComponents/KrActions/KrActions";
import {
  useGetWebObjectiveDetailsCheckinMeetingByTeamId,
  useGetWebObjectiveDetailsCheckinMeetingByTeamId2,
} from "../../Meeting/Hooks/index";
import {
  useGetKeyResultMeetingHistory,
  useDisLikeMeeting,
  useLikeMeeting,
  useAddLikeMeetingKeyResult,
  useAddDisLikeMeetingKeyResult
} from "../Hooks/index";
import KrHistoryModalContent from "../LComponents/KrHistoryModalContent/KrHistoryModalContent";
import {
  ObjectiveSelectedFace,
  krSelectedFace,
} from "../Interfaces/interfaces";
import DyDataGrid from "../../../components/GlobalComponents/DyDataGrid2/DyDataGrid";
import DyDataGridObj from "../../../components/GlobalComponents/DyDataGridObj/DyDataGridObj";
import { useSelector } from "react-redux";
import { EmptyDataIcon } from "../StataicData/index";
import TeamsNavigations from "../LComponents/TeamsNavigation/TeamsNavigations";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import DYToastMessage from "../../../components/GlobalComponents/DyToastMessage/DYToastMessage";
import smil from "../../../Asset/Svgs/Emojys/smil.png";
import meh from "../../../Asset/Svgs/Emojys/meh.png";
import sad from "../../../Asset/Svgs/Emojys/sad.png";
import { changeTreeViewStateR } from "../../Meeting/MeetingsSlice/MeetingsSlice";
import { useDispatch } from "react-redux";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import { CircularProgress } from "@mui/material";
import { CreateKReval } from "../LComponents/Forms/CreateKReval/CreateKReval";
import LikeIcon from "@mui/icons-material/Favorite";
import LyBackdrop from "../../../components/Layouts/BackDrop/BackDrop";
import "../../CompanyManagment/Copmonents/Like/Like.css";
import { NewUseStore } from "../../../Store/newUseStore";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import { thousandSeparator } from "../../../helper/lib";
import CommentModal from "../../TenantDash/LComponents/AllTenantDash/AnotherComponent ";
import { CreateAttachment } from "../LComponents/Forms/CreateAttachment/CreateAttachment";
import { CreateAttachmentObj } from "../LComponents/Forms/CreateAttachmentObj/CreateAttachmentObj";
import AttachmentIcon from '@mui/icons-material/Attachment';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import CooperationRequest from "../LComponents/CooperationRequest/CooperationRequest";
const ObjectiveKeyResults: React.FC = () => {
  const dispatch = useDispatch();
  const treeView = useSelector(
    (state: any) => state.meetings.treeViewState?.treeView
  );
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // برای بررسی سایز صفحه
  const priodId: any = useSelector((state: any) => state.meetings.priodId);
  const personId=useSelector((state:any)=>state.loign.personId);
  const meetingId: any = useSelector((state: any) => state.meetings.meetingId);
  const [objectivies, setObjectivies] = useState([]);
  const nodeId = NewUseStore((state) => state.newCompanyId);
  const [objectiveSelectedData, setObjectiveSelectedData] = useState<any>(null);
  const [objectiveManiInfo, setObjectiveMainInfo] =
    useState<ObjectiveSelectedFace | null>(null);
  const [SuccessState, setSuccessState] = useState<boolean>(true);
  const [keyR, setKeyR] = useState<any>([]);
  const [objId, setObjeId] = useState<any>();

  const getObjectiveSuccess = (data: any) => {
    if (data && data.length > 0) {
      setObjectivies(data);
      const selectedRow = objectiveSelectedData
        ? (data.find((item: any) => item.id === objectiveSelectedData.id) ||
          data[0])
        : data[0];
      setRowSelectedData(selectedRow);
      let { name, id } = selectedRow;
      let ObjSelected = {
        name: name,
        id: id,
      };
      
      setObjectiveMainInfo(ObjSelected);
      //setObjectiveSelectedData(data[0]);
      let keyrs = (selectedRow as any).keyResultCheckingMeetingQueryResultDto
        ? (selectedRow as any).keyResultCheckingMeetingQueryResultDto
        : [];
      const keyRTmp = keyrs.map((item: any) => ({
        ...item,
        oldValue: thousandSeparator(item.oldValue),
        oneValue: thousandSeparator(item.oneValue),
        sevenTenthsValue: thousandSeparator(item.sevenTenthsValue),
        threeTenthsValue: thousandSeparator(item.threeTenthsValue),
        startValue: thousandSeparator(item.startValue),
        currentValue: thousandSeparator(item.currentValue),
      }));
      setKeyR(keyRTmp);
      setObjSelectionModel((selectedRow as any).id);
    }
    setSuccessState(false);
  };

  const getObjectiveError = () => {};

  const {
    data,
    isError: getObjectiveErrorFlag,
    isFetched: getObjectiveAgainFetched,
    isLoading: getObjLoading,
    refetch: callAgain,
  } = useGetWebObjectiveDetailsCheckinMeetingByTeamId(
    getObjectiveSuccess,
    getObjectiveError,
    nodeId,
    priodId,
    meetingId
  );

  //
  const companyNode: any = useSelector(
    (state: any) => state.meetings.companyList
  );
  const KRinitialStatee = useSelector(
    (state: any) => state.loign.kRinitialState
  );
  const ObjctivieInitialState = useSelector(
    (state: any) => state.loign.ObjctivieInitialState
  );

  const objUpdated = useSelector((state: any) => state.meetings.objUpdated);
  const teamInfo = useSelector((state: any) => state.meetings.teamInfo);
  const [showModal, setShowModal] = useState(false);
  const [justMyKr, setJustMyKr] = useState(false);
  const [historyModal, setHistoryModal] = useState(false);
  const [showAttachment, setShowAttachment] = useState(false);
  const [showAttachment1, setShowAttachment1] = useState(false);
  const [krRowData, setKrRowData] = useState(null);
  const [showToolbarModal, setShowToolbarModal] = useState<Boolean | null>(
    false
  );
  const [showAddEvalModal, setShowAddEvalModal] = useState<Boolean>(false);
  const [ShowActionsModal, setShowActionsModal] = useState<Boolean>(false);
  const [ShowActionsModal1, setShowActionsModal1] = useState<Boolean>(false);
  const [pointingSystem, setPointingSystem] = useState<string | null>(null);
  const { mutate: likeMeeting, data: likeData } = useLikeMeeting();
  const { mutate: likeKrMeeting, data: likeKrData } = useAddLikeMeetingKeyResult();
  const { mutate: disLikeMeeting, data: disLikeData } = useDisLikeMeeting();
  const { mutate: disLikeKrMeeting, data: disLikeKrData } = useAddDisLikeMeetingKeyResult();
  const tenantId = useSelector((state: any) => state.meetings.profileTenantId);
  const [rowSelectedData, setRowSelectedData] = useState<any>(null);
  const [krMainInfo, setKrMainInfo] = useState<krSelectedFace | null>(null);
  const [showToastMessage, setShowToastMessage] = useState<any>(false);
  const [addEvalAsyncData, setAddEvalAsyncData] = useState<any>(null);

  const [objectivee, setObjectivee] = useState<any>(
    objectivies?.length > 4 ? "fb7cc4ea-7162-4916-9aa8-834b14308e10" : null
  );

  useEffect(() => {
    if (justMyKr) {
      setMyKeysResultsList();
      renderContents();
    }else{
      setKeysResultsList();
      renderContents();
    }
  }, [justMyKr]);

  useEffect(() => {
    if (!getObjectiveAgainFetched) {
      setObjectivies([]);
      setJustMyKr(false);
      setKeyR([]);
      setObjectiveMainInfo(null);
    } 
  }, [getObjectiveAgainFetched]);

  useEffect(() => {
    if (addEvalAsyncData) {
      callAgain();
      setSuccessState(true);
    }
  }, [addEvalAsyncData]);

  const [objcSelectionModel, setObjSelectionModel] = useState<string | any>(
    localStorage.getItem("objcSelectionModel")
  );
  const [krSelectionModel, setKrSelectionModel] = useState<string | any>(
    localStorage.getItem("krSelectionModel")
  );

  const [getCustomerBody, setGetCustomerBody] = useState<any>({
    pageSize: 50000,
    page: 1,
    searchTerm: "",
  });
  const [krId, setKrId] = useState(null);
  const {
    data: KrHistoryData,
    isLoading: KRHLoading,
    isError: KRHError,
    isFetched: KRHFetched,
  } = useGetKeyResultMeetingHistory(krId, priodId, meetingId);

  useEffect(() => {
    if (objectiveSelectedData) {
      let { name, id } = objectiveSelectedData;
      let ObjSelected = {
        name: name,
        id: id,
      };
      setObjeId(id);
      setObjectiveMainInfo(ObjSelected);
    }
  }, [objectiveSelectedData]);


  useEffect(() => {
    localStorage.setItem("krSelectionModel", krSelectionModel);
  }, [krSelectionModel]);

  useEffect(() => {
    localStorage.setItem("objcSelectionModel", objcSelectionModel);
  }, [objcSelectionModel]);

  useEffect(() => {
    const krSelectionModel = localStorage.getItem("krSelectionModel");
    if (krSelectionModel) {
      setKrSelectionModel(krSelectionModel);
    }
  }, [addEvalAsyncData]);

  const [imgSrc, setImgSrc] = useState<string | null>(null);
  const [showImageSelector, setShowImageSelector] = useState<boolean>(false);
  const handleImageChange = (newImgSrc: string) => {
    setImgSrc(newImgSrc);
    localStorage.setItem('tenantImage', newImgSrc); // Save to localStorage
    setShowImageSelector(false);
  };
  const handleToastMessage = (message: string) => {
    setShowToastMessage(true);
    setTimeout(() => setShowToastMessage(false), 3000); // Hide toast after 3 seconds
  };

  const handleImageSelectorClose = () => {
    setShowImageSelector(false);
  };

  useEffect(() => {
    if (rowSelectedData) {
      let {
        name,
        id,
        responsibleName,
        startDate,
        startValue,
        threeTenthsValue,
        sevenTenthsValue,
        oneValue,
        currentValue,
        problems,
        attachment,
        predict,
        currentStateValue,
        description,
        score,
        revenue,
        revenueTwo,
        okR_KeyResultType,
      } = rowSelectedData;
      let krSelected: krSelectedFace = {
        name: name,
        id: id,
        responsibleName: responsibleName,
        startDate: startDate,
        startValue: startValue,
        threeTenthsValue: threeTenthsValue,
        sevenTenthsValue: sevenTenthsValue,
        oneValue: oneValue,
        currentValue: currentValue,
        problems: problems,
        attachment: attachment,
        nextState: predict,
        currentState: currentStateValue,
        description: description,
        score: score,
        revenue: revenue,
        revenueTwo: revenueTwo,
        okR_KeyResultType: okR_KeyResultType,
      };
      setKrMainInfo(krSelected);
    }
  }, [rowSelectedData]);
  const [likec, setLikeCount] = useState<number>(0);
  const [likeKrc, setLikeKrCount] = useState<number>(0);
  const [activeBtn, setActiveBtn] = useState<string>("none");

  const initialLikeObject = (iddd : string) => {
    let deleteBody = {
      objectiveId:iddd,
      tenantId: tenantId,
      meetingId: meetingId,
    };
    likeMeeting(deleteBody);
  };

  const initialLikeKr = (iddd : string) => {
    let deleteBody = {
      keyResultId:iddd,
      tenantId: tenantId,
      meetingId: meetingId,
    };
    likeKrMeeting(deleteBody);
  };

  const initialDisLikeObject = (iddd : string) => {
    let deleteBody = {
      objectiveId:iddd,
      tenantId: tenantId,
      meetingId: meetingId,
    };
    disLikeMeeting(deleteBody);
  };

  const initialDisLikeKr = (iddd : string) => {
    let deleteBody = {
      keyResultId:iddd,
      tenantId: tenantId,
      meetingId: meetingId,
    };
    disLikeKrMeeting(deleteBody);
  };
  
  const handleReactionClick = (reaction: string, iddd : string): void => {
    if (activeBtn === "none") {
      if (reaction === "like") {
        setLikeCount(likec + 1);
        setActiveBtn("like");
        initialLikeObject(iddd);
      }
    } else if (activeBtn === reaction) {
      if (reaction === "like") {
        setLikeCount(likec - 1);
        initialDisLikeObject(iddd);
      }
      setActiveBtn("none");
    } else if (activeBtn !== reaction) {
      if (reaction === "like") {
        setActiveBtn("like");
      }
    }
  };
  const handleComment= (id: string, name : string): void => {
    <CommentModal id={id} name={name} />
  };
    const [columnWidths, setColumnWidths] = useState({
    comment: 100,
    name: 400,
    name2: 570,
    responsibleName: 125,
    responsibleName2: 125,
    keyResultCount:100,
    objectivesStateName:150,
    evaluationPercentage:90,
    oldScore:75,
    score:75,
    difference:100,
    difference2:100,
    currentState:110,
    combinedScore:120,
    evaluationSummary:400,
    combinedField:160,
    oldValue:115,
    oldScore2:75,
    combinedValue:120,
  });
  const handleMouseDown = (e: React.MouseEvent, field: keyof typeof columnWidths) => {
    const startX = e.clientX; // موقعیت اولیه دستگیره
    const startWidth = columnWidths[field]; // عرض اولیه ستون
  
    // به محض شروع کشیدن، نیاز داریم که محل فعلی (x) تغییرات را نگه داریم
    const handleMouseMove = (e: MouseEvent) => {
      const delta = e.clientX - startX; // فاصله تغییرات موس از موقعیت اولیه
      const newWidth = Math.max(50, startWidth - delta); // تغییر اندازه ستون از سمت چپ
  
      // برای اینکه ستون از سمت چپ گسترش یابد، باید موقعیت آن را تغییر دهیم
      setColumnWidths((prev) => ({
        ...prev,
        [field]: newWidth, // ستون به عرض جدید تنظیم می‌شود
      }));
    };
  
    const handleMouseUp = () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };
  
    // افزودن لیسنر برای حرکت موس و رها کردن آن
    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
  };
  
  // استایل‌های هدر و دستگیره
  const headerCellStyle: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.2)', // سایه برای برجسته شدن ستون
  };
  
  const resizeHandleStyle: React.CSSProperties = {
    width: '100%',  // عرض دستگیره به اندازه کافی بزرگ باشد
    height: '100%',
    cursor: 'ew-resize',
    position: 'absolute',
    right: 0,  // دستگیره در انتهای ستون قرار بگیرد
    top: 0,
    bottom: 0,
    zIndex: 10,  // اطمینان از اینکه دستگیره بالای سایر اجزا باشد
        // backgroundColor: '#ccc', // رنگ پس‌زمینه برای دستگیره

  };
  
  const objectiveColumns: any = [
    {
      field: "rowid",
      headerName: "ردیف",
      width: 35,

      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: (params: any) =>
        params.api.getAllRowIds().indexOf(params.id) + 1,
    },
    {
      field: 'comment',
      headerName: 'نظرات',
      align: 'center',
      headerAlign: 'center',
      sortable: false,
      width: columnWidths.comment,
      renderHeader: (params:any) => (
        <div style={headerCellStyle}>
          {params.colDef.headerName}
          <div
            style={resizeHandleStyle}
            onMouseDown={(e) => handleMouseDown(e, 'comment')}
          />
        </div>
      ),
      renderCell: (params: GridRenderCellParams) => {
        const id: string = params.row.id;
        const name: string = params.row.name;
        const row: any = params.row;
        const commentCount: number = params.row.commentCount;
        const attachment: any = params.row.attachment;
        return (
          <Box display="flex" justifyContent="space-between" alignItems="center" style={{ width: "100%" }}>
        
          {/* آیکون ضمیمه */}
          <Box sx={{ width: "40px", textAlign: "center" }}>
            {attachment && (
              <Tooltip title="ضمیمه موجود است">
                <Button
              sx={{ fontSize: "10px" }}
              variant="text"
              onClick={() => {
                setShowAttachment1((prev: any) => !prev);
                setObjeId(id);
                setKrMainInfo(row);
              }}
              startIcon={<AttachmentIcon />}
            >
            </Button>
              </Tooltip>
            )}
          </Box>
          <Box display="flex" justifyContent="end">
            <CommentModal id={id} name={name} meetingId={meetingId} commentCount={commentCount} />
          </Box>
          </Box>
        );
      },
    },
    {
      field: 'name',
      headerName: 'شرح هدف',
      align: 'left',
      headerAlign: 'center',
      sortable: false,
      // flex: 1, // برای اینکه ستون فضای اضافی را اشغال کند
      width: columnWidths.name2,
      renderHeader: (params:any) => (
        <div style={headerCellStyle}>
          {params.colDef.headerName}
          <div
            style={resizeHandleStyle}
            onMouseDown={(e) => handleMouseDown(e, 'name2')}
          />
        </div>
      ),
      renderCell: ({ value }: { value: string }) => (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            overflow: 'hidden', // از خروج متن از سلول جلوگیری می‌کند
            whiteSpace: 'nowrap', // از شکستن متن به خطوط جدید جلوگیری می‌کند
            width: '100%', // عرض ستون
          }}
        >
          {value.length > 200 ? (
  <Tooltip title={value}>
    <Typography sx={{ fontSize: '12px' }}>
      {value}
    </Typography>
  </Tooltip>
) : (
  <Typography sx={{ fontSize: '12px' }}>
    {value}
  </Typography>
)}
        </Box>
      ),
    },
    {
      field: 'responsibleName',
      headerName: 'مسئول',
      align: 'center',
      headerAlign: 'center',
      sortable: false,
      width: columnWidths.responsibleName,
      renderHeader: (params:any) => (
        <div style={headerCellStyle}>
          {params.colDef.headerName}
          <div
            style={resizeHandleStyle}
            onMouseDown={(e) => handleMouseDown(e, 'responsibleName')}
          />
        </div>
      ),
    },
    {
      field: "keyResultCount",
      headerName: "تعداد نتایج",
      align: "center",
      headerAlign: "center",
      sortable: false,
      width: columnWidths.keyResultCount,
      renderHeader: (params:any) => (
        <div style={headerCellStyle}>
          {params.colDef.headerName}
          <div
            style={resizeHandleStyle}
            onMouseDown={(e) => handleMouseDown(e, "keyResultCount")}
          />
        </div>
      ),
    },
    {
      field: "objectivesStateName",
      headerName: "وضعیت هدف",
      sortable: false,
      headerAlign: "center",
      align: "center",
      width: columnWidths.objectivesStateName,
      renderHeader: (params:any) => (
        <div style={headerCellStyle}>
          {params.colDef.headerName}
          <div
            style={resizeHandleStyle}
            onMouseDown={(e) => handleMouseDown(e, "objectivesStateName")}
          />
        </div>
      ),
      renderCell: ({ value }: any) => {
        return (
          <Box
            m={3}
            borderRadius={2}
            width={"100%"}
            display={"flex"}
            justifyContent={"center"}
            alignItems={"center"}
            height={"75%"}
            bgcolor={value === "فعال" ? "#D5F7D4" : "#E5F1FF"}
          >
            <Typography fontSize={"0.8rem"} px={8}>
              {value}
            </Typography>
          </Box>
        );
      },
    },
    {
      field: "weight",
      headerName: "وزن",
      sortable: false,
      hideable: true,
      hide: true,
      headerAlign: "center",
      align: "center",
      width: 80,
    },
    {
      field: "evaluationPercentage",
      headerName: "درصد ارزیابی",
      align: "center",
      sortable: false,
      headerAlign: "center",
      // width: 120,
      width: columnWidths.evaluationPercentage,
      renderHeader: (params:any) => (
        <div style={headerCellStyle}>
          {params.colDef.headerName}
          <div
            style={resizeHandleStyle}
            onMouseDown={(e) => handleMouseDown(e, 'evaluationPercentage')}
          />
        </div>
      ),

    },
    {
      field: "oldScore2",
      headerName: "امتیاز قبلی",
      align: "center",
      sortable: false,
      headerAlign: "center",
      // width: 75,
      width: columnWidths.oldScore2,

      renderHeader: (params: any) => (
        <div style={headerCellStyle}>
          {params.colDef.headerName}
          <div
            style={resizeHandleStyle}
            onMouseDown={(e) => handleMouseDown(e, "oldScore2")} // به همین صورت برای ستون‌های دیگر هم تنظیم کنید
          />
        </div>
      ),
      
      renderCell: (par: any) => {
        let value: number = par?.row?.oldScore;
    
        let color = "";
        let fColor = "";
        switch (true) {
          case value >= 70:
            color = "#D5F7D4";
            fColor = "#125610";
            break;
          case value < 70 && value > 30:
            color = "#FFF8D0";
            fColor = "#6B6440";
            break;
          default:
            color = "#FFEEE5";
            fColor = "#993600";
            break;
        }
        return (
          <Box
            m={3}
            borderRadius={2}
            width={"100%"}
            display={"flex"}
            justifyContent={"center"}
            alignItems={"center"}
            height={"75%"}
            bgcolor={color}
          >
            <Typography
              px={8}
              color={fColor}
              fontSize={"0.8rem"}
              fontWeight={400}
            >
              {value}
            </Typography>
          </Box>
        );
      },
    },
    {
      field: "score",
      headerName: "امتیاز جدید",
      align: "center",
      sortable: false,
      headerAlign: "center",
      // width: 75,
      width: columnWidths.score,
      renderHeader: (params: any) => (
        <div style={headerCellStyle}>
          {params.colDef.headerName}
          <div
            style={resizeHandleStyle}
            onMouseDown={(e) => handleMouseDown(e, "score")}
          />
        </div>
      ),
      renderCell: (par: any) => {
        let value: number = par?.row?.score;
    
        let color = "";
        let fColor = "";
        switch (true) {
          case value >= 70:
            color = "#D5F7D4";
            fColor = "#125610";
            break;
          case value < 70 && value > 30:
            color = "#FFF8D0";
            fColor = "#6B6440";
            break;
          default:
            color = "#FFEEE5";
            fColor = "#993600";
            break;
        }
        return (
          <Box
            m={3}
            borderRadius={2}
            width={"100%"}
            display={"flex"}
            justifyContent={"center"}
            alignItems={"center"}
            height={"75%"}
            bgcolor={color}
          >
            <Typography
              px={8}
              color={fColor}
              fontSize={"0.8rem"}
              fontWeight={800}
            >
              {value}
            </Typography>
          </Box>
        );
      },
    },
    {
      field: "difference2",
      headerName: "تفاوت",
      align: "center",
      sortable: false,
      headerAlign: "center",
      // width: 100,
      width: columnWidths.difference2,
      renderHeader: (params: any) => (
        <div style={headerCellStyle}>
          {params.colDef.headerName}
          <div
            style={resizeHandleStyle}
            onMouseDown={(e) => handleMouseDown(e, "difference2")}
          />
        </div>
      ),
      renderCell: (param: any) => {
        let difference: string = param?.row?.difference;
        let postive;
        if (difference && difference !== '0' && difference !== "-") {
          postive = difference.includes("-");
          return (
            <Box
              display={"flex"}
              alignItems={"center"}
              justifyContent={"center"}
              columnGap={1}
            >
              <Typography fontSize={"0.6rem"}>
                {difference.replace("-", "")}
              </Typography>
              {!postive ? (
                <TrendingUpIcon color="secondary" />
              ) : (
                <TrendingDownIcon color="error" />
              )}
            </Box>
          );
        } else if (difference && difference !== '0') {
          return (
            <Box
              display={"flex"}
              alignItems={"center"}
              justifyContent={"center"}
              columnGap={1}
            >
              <Typography fontSize={"0.6rem"}>{difference}</Typography>
            </Box>
          );
        } else {
          return (
            <Typography fontSize={"0.6rem"}>
              {difference}
            </Typography>
          );
        }
      },
    },
  ];

  const keyResultColumn: any = [
    {
      field: "rowidd",
      headerName: "ردیف",
      width: 35,
      hideable: true,
      hide: true,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: (params: any) =>
        params.api.getAllRowIds().indexOf(params.id) + 1,
    },
{
  field: "combinedField",
  headerName: "",
  align: "center",
  headerAlign: "center",
  sortable: false,
  width: columnWidths.combinedField,
  renderHeader: (params:any) => (
    <div style={headerCellStyle}>
      {params.colDef.headerName}
      <div
        style={resizeHandleStyle}
        onMouseDown={(e) => handleMouseDown(e, 'combinedField')}
      />
    </div>
  ),
  renderCell: ({ row }: any) => {
    const { problems, description, commentCount, id, name, nextState, attachment } = row;

    const handleDoubleClick = () => {
      setKrId(id);
      setShowAddEvalModal(true);
    };

    return (
      <Box display="flex" justifyContent="space-between" alignItems="center" style={{ width: "100%" }}>
        <Box sx={{ width: "40px", textAlign: "center" }}>
        
          {attachment && (
            <Tooltip title="ضمیمه موجود است">
              <Button
              sx={{ fontSize: "10px" }}
              variant="text"
              onClick={() => {
                setShowAttachment((prev: any) => !prev);
                setKrId(id);
                setKrMainInfo(row);
              }}
              startIcon={<AttachmentIcon />}
            >
            </Button>
            </Tooltip>
          )}
        </Box>

        <Box sx={{ width: "40px", textAlign: "center", cursor: "pointer" }} onDoubleClick={handleDoubleClick}>
          {problems && (
            <Tooltip title={`موانع: ${problems}`} sx={{ fontSize: "1.5rem !important" }}>
              <MailOutlineIcon sx={{ fontSize: "18px" }} />
            </Tooltip>
          )}
        </Box>

        <Box sx={{ width: "40px", textAlign: "center", cursor: "pointer" }} onDoubleClick={handleDoubleClick}>
          {description && (
            <Tooltip title={`توضیحات: ${description}`} sx={{ fontSize: "1.5rem !important" }}>
              <MailOutlineIcon sx={{ fontSize: "18px" }} />
            </Tooltip>
          )}
        </Box>

        {/* وضعیت آتی */}
        <Box sx={{ width: "80px", textAlign: "center" }}>
          {nextState && (
            <Tooltip title={nextState}>
              {(() => {
                switch (nextState) {
                  case "انتظار داریم به نتیجه درست برسیم":
                    return <img src={smil} width={"25px"} style={{ verticalAlign: 'middle' }} />;
                  case "با ریسک عدم دستیابی مواجه هستیم اما تمام تلاش خود را خواهیم کرد":
                    return <img src={meh} width={"25px"} style={{ verticalAlign: 'middle' }} />;
                  case "اعتقادی نداریم به نتیجه برسیم مگر اینکه رویکرد جدیدی اتخاذ کنیم":
                    return <img src={sad} width={"25px"} style={{ verticalAlign: 'middle' }} />;
                  default:
                    return <span />;
                }
              })()}
            </Tooltip>
          )}
        </Box>

        {/* نظرات */}
        <Box sx={{ width: "40px", textAlign: "center" }}>
          <CommentModal id={id} name={name} meetingId={meetingId} commentCount={commentCount} />
        </Box>
      </Box>
    );
  },
}
,
{
  field: "evaluationSummary",
  headerName: "شرح تکمیل شده",
  align: "left",
  headerAlign: "center",
  sortable: false,
  // minWidth: 400,
  width: columnWidths.evaluationSummary,
  renderHeader: (params:any) => (
    <div style={headerCellStyle}>
      {params.colDef.headerName}
      <div
        style={resizeHandleStyle}
        onMouseDown={(e) => handleMouseDown(e, 'evaluationSummary')}
      />
    </div>
  ),
  renderCell: ({ row }: any) => {
      const {
          pointingSystemType,
          name,
          startValue,
          sevenTenthsValue,
          oneValue,
          measurementUnit,
          reportingPeriod,
      } = row;

      // انتخاب مقدار هدف نهایی بر اساس نوع سیستم امتیازدهی
      const targetValue = pointingSystemType === "تارگت کششی" ? sevenTenthsValue : oneValue;

      // فرمت‌دهی برای نمایش اعداد منفی
      const formattedStartValue = startValue < 0 ? `-${Math.abs(startValue)}` : startValue;
      const formattedTargetValue = targetValue < 0 ? `-${Math.abs(targetValue)}` : targetValue;

      // ساختن متن شرح تکمیل شده با فرمت‌دهی اعداد منفی
      const evaluationText = `${name} از ${formattedStartValue} به ${formattedTargetValue} ${measurementUnit} - ${reportingPeriod}`;

      return (
          <Box
              sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
              }}
          >
              {evaluationText.length > 40 ? (
                  <Tooltip title={<Typography>{evaluationText}</Typography>} placement="top" arrow>
                      <Typography sx={{ fontSize: "12px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                          {evaluationText}
                      </Typography>
                  </Tooltip>
              ) : (
                  <Typography sx={{ fontSize: "12px" }}>{evaluationText}</Typography>
              )}
          </Box>
      );
  },
}
,
    
    
    {
      field: "name",
      headerName: "شرح نتیجه کلیدی",
      align: "left",
      headerAlign: "center",
      sortable: true,
      minWidth: 300,
      hideable: true,
      hide: true,
      renderCell: ({ value, row }: any) => {
        return (
          <div
            onDoubleClick={() => {
              if (row && row.id) {
                setKrId(row.id);
                setShowAddEvalModal(true); // باز کردن مدال
              }
            }}
            style={{ width: "100%", cursor: "pointer" }} // تنظیم عرض و نشانگر موس
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              {value.length > 40 ? (
                <Tooltip sx={{ fontSize: "1.5rem !important" }} title={value}>
                  {value}
                </Tooltip>
              ) : (
                <Typography sx={{ fontSize: "12px" }}>{value}</Typography>
              )}
            </Box>
          </div>
        );
      },
    },    
    {
      field: "measurementUnit",
      headerName: "معیار سنجش",
      align: "center",
      headerAlign: "center",
      sortable: false,
      minWidth: 60,
      hideable: true,
      hide: true,
      fontsize: "14px",
      renderCell: ({ value, row }: any) => {
        return (
          <div
            onDoubleClick={() => {
              if (row && row.id) {
                setKrId(row.id);
                setShowAddEvalModal(true); // باز کردن مدال
              }
            }}
            //style={{ width: "100%", cursor: "pointer" }} // تنظیم عرض و نشانگر موس
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              {value.length > 40 ? (
                <Tooltip sx={{ fontSize: "1.5rem !important" }} title={value}>
                  {value}
                </Tooltip>
              ) : (
                <Typography sx={{ fontSize: "12px" }}>{value}</Typography>
              )}
            </Box>
          </div>
        );
      },
    },
    {
      field: "reportingPeriod",
      headerName: "منطق گزارش دهی",
      align: "center",
      headerAlign: "center",
      sortable: false,
      minWidth: 60,
      hideable: true,
      hide: true,
      fontsize: "14px",
      renderCell: ({ value, row }: any) => {
        return (
          <div
            onDoubleClick={() => {
              if (row && row.id) {
                setKrId(row.id);
                setShowAddEvalModal(true); // باز کردن مدال
              }
            }}
            //style={{ width: "100%", cursor: "pointer" }} // تنظیم عرض و نشانگر موس
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              {value.length > 40 ? (
                <Tooltip sx={{ fontSize: "1.5rem !important" }} title={value}>
                  {value}
                </Tooltip>
              ) : (
                <Typography sx={{ fontSize: "12px" }}>{value}</Typography>
              )}
            </Box>
          </div>
        );
      },
    },
    {
      field: "responsibleName",
      headerName: "مسئول ",
      align: "center",
      headerAlign: "center",
      sortable: false,
      // minWidth: 105,
      width: columnWidths.responsibleName2,
      renderHeader: (params:any) => (
        <div style={headerCellStyle}>
          {params.colDef.headerName}
          <div
            style={resizeHandleStyle}
            onMouseDown={(e) => handleMouseDown(e, 'responsibleName2')}
          />
        </div>
      ),
      fontsize: "14px",
      renderCell: ({ value, row }: any) => {
        return (
          <div
            onDoubleClick={() => {
              if (row && row.id) {
                setKrId(row.id);
                setShowAddEvalModal(true); // باز کردن مدال
              }
            }}
            //style={{ width: "100%", cursor: "pointer" }} // تنظیم عرض و نشانگر موس
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              {value.length > 40 ? (
                <Tooltip sx={{ fontSize: "1.5rem !important" }} title={value}>
                  {value}
                </Tooltip>
              ) : (
                <Typography sx={{ fontSize: "12px" }}>{value}</Typography>
              )}
            </Box>
          </div>
        );
      },
    },
    {
      field: "okrStateName",
      headerName: "وضعیت نتیجه",
      align: "center",
      hideable: true,
      hide: true,
      sortable: false,

      headerAlign: "center",
      width: 140,
      renderCell: ({ value , row }: any) => {
        return (
          <div
            onDoubleClick={() => {
              if (row && row.id) {
                setKrId(row.id);
                setShowAddEvalModal(true); // باز کردن مدال
              }
            }}
            style={{ width: "100%", cursor: "pointer" }} // تنظیم عرض و نشانگر موس
          >
          <Box
            borderRadius={2}
            width={"100%"}
            display={"flex"}
            justifyContent={"center"}
            alignItems={"center"}
            height={"75%"}
            bgcolor={value === "فعال" ? "#D5F7D4" : "#E5F1FF"}
          >
            <Typography>{value}</Typography>
          </Box>
          </div>
        );
      },
    },
    {
      field: "okR_KeyResultType",
      align: "center",
      headerName: "نوع",
      headerAlign: "center",
      sortable: false,
      width: 110,
      hideable: true,
      hide: true,
      renderCell: ({ value , row}: any) => {
        return (
          <div
            onDoubleClick={() => {
              if (row && row.id) {
                setKrId(row.id);
                setShowAddEvalModal(true); // باز کردن مدال
              }
            }}
            //style={{ width: "100%", cursor: "pointer" }} // تنظیم عرض و نشانگر موس
          >
        <Typography fontSize={"12px"}>{value}</Typography>
        </div>
      );
      },
    },
    {
      field: "pointingSystemType",
      align: "center",
      headerName: "سیستم امتیازدهی",
      headerAlign: "center",
      sortable: false,
      width: 120,
      hideable: true,
      hide: true,
      renderCell: ({ value, row }: any) => {
        return (
          <div
            onDoubleClick={() => {
              if (row && row.id) {
                setKrId(row.id);
                setShowAddEvalModal(true); // باز کردن مدال
              }
            }}
            //style={{ width: "100%", cursor: "pointer" }} // تنظیم عرض و نشانگر موس
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              {value.length > 40 ? (
                <Tooltip sx={{ fontSize: "1.5rem !important" }} title={value}>
                  {value}
                </Tooltip>
              ) : (
                <Typography sx={{ fontSize: "12px" }}>{value}</Typography>
              )}
            </Box>
          </div>
        );
      },

    },
    // {
    //   field: "startValue",
    //   align: "center",
    //   headerName: "شروع",
    //   headerAlign: "center",
    //   sortable: false,
    //   width: 70,
    //   hideable: true,
    //   hide: true,
    //   renderCell: ({ value ,row}: any) => {
    //     return (
    //       <div
    //         onDoubleClick={() => {
    //           if (row && row.id) {
    //             setKrId(row.id);
    //             setShowAddEvalModal(true); // باز کردن مدال
    //           }
    //         }}
    //         style={{ width: "100%", display: "flex", justifyContent:"center", alignItems:"center" }} 
    //       >
    //       <Box>
    //         {value.length > 5 ? (
    //           <Tooltip sx={{ fontSize: "1.5rem !important" }} title={value}>
    //             {value}
    //           </Tooltip>
    //         ) : (
    //           <Typography sx={{ fontSize: "12px" }}>{value}</Typography>
    //         )}
    //       </Box>
    //       </div>
    //     );
    //   },
    // },
    // {
    //   field: "threeTenthsValue",
    //   align: "center",
    //   headerName: "30%",
    //   headerAlign: "center",
    //   sortable: false,
    //   width: 70,
    //   hideable: true,
    //   hide: true,
    //   renderCell: ({ value ,row }: any) => {
    //     return (
    //       <div
    //         onDoubleClick={() => {
    //           if (row && row.id) {
    //             setKrId(row.id);
    //             setShowAddEvalModal(true); // باز کردن مدال
    //           }
    //         }}
    //         style={{ width: "100%", display: "flex", justifyContent:"center", alignItems:"center" }} 
    //       >
    //       <Box>
    //         {value.length > 5 ? (
    //           <Tooltip sx={{ fontSize: "1.5rem !important" }} title={value}>
    //             {value}
    //           </Tooltip>
    //         ) : (
    //           <Typography sx={{ fontSize: "12px" }}>{value}</Typography>
    //         )}
    //       </Box>
    //       </div>
    //     );
    //   },
    // },
    // {
    //   field: "sevenTenthsValue",
    //   align: "center",
    //   headerName: "70%",
    //   headerAlign: "center",
    //   sortable: false,
    //   width: 70,
    //   hideable: true,
    //   hide: true,
    //   renderCell: ({ value , row}: any) => {
    //     return (
    //       <div
    //         onDoubleClick={() => {
    //           if (row && row.id) {
    //             setKrId(row.id);
    //             setShowAddEvalModal(true); // باز کردن مدال
    //           }
    //         }}
    //         //style={{ width: "100%", cursor: "pointer" }} // تنظیم عرض و نشانگر موس
    //       >
    //       <Box>
    //         {value.length > 5 ? (
    //           <Tooltip sx={{ fontSize: "1.5rem !important" }} title={value}>
    //             {value}
    //           </Tooltip>
    //         ) : (
    //           <Typography textAlign={"center"} sx={{ fontSize: "12px" }}>
    //             {value}
    //           </Typography>
    //         )}
    //       </Box>
    //       </div>
    //     );
    //   },
    // },
    // {
    //   field: "oneValue",
    //   align: "center",
    //   headerName: "100%",
    //   headerAlign: "center",
    //   sortable: false,
    //   width: 80,
    //   hideable: true,
    //   hide: true,
    //   renderCell: ({ value , row}: any) => {
    //     return (
    //       <div
    //         onDoubleClick={() => {
    //           if (row && row.id) {
    //             setKrId(row.id);
    //             setShowAddEvalModal(true); // باز کردن مدال
    //           }
    //         }}
    //         style={{ width: "100%", display: "flex", justifyContent:"center", alignItems:"center" }} 
    //       >
    //       <Box>
    //         {value.length > 5 ? (
    //           <Tooltip sx={{ fontSize: "1.5rem !important" }} title={value}>
    //             {value}
    //           </Tooltip>
    //         ) : (
    //           <Typography sx={{ fontSize: "12px" }}>{value}</Typography>
    //         )}
    //       </Box>
    //       </div>
    //     );
    //   },
    // },
    // {
    //   field: "startValue",
    //   align: "center",
    //   headerName: "شروع",
    //   headerAlign: "center",
    //   sortable: false,
    //   width: 70,
    //   hideable: true,
    //   hide: true,
    //   renderCell: ({ value, row }: any) => {
    //     return (
    //       <div
    //         onDoubleClick={() => {
    //           if (row && row.id) {
    //             setKrId(row.id);
    //             setShowAddEvalModal(true); // باز کردن مدال
    //           }
    //         }}
    //         style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}
    //       >
    //         <Box>
    //           {value.length > 5 ? (
    //             <Tooltip sx={{ fontSize: "1.5rem !important" }} title={value}>
    //               {value}
    //             </Tooltip>
    //           ) : (
    //             <Typography sx={{ fontSize: "12px" }}>
    //               {value < 0 ? `${Math.abs(value)} -` : value}
    //             </Typography>
    //           )}
    //         </Box>
    //       </div>
    //     );
    //   },
    // },
    {
      field: "startValue",
      align: "center",
      headerName: "شروع",
      headerAlign: "center",
      sortable: false,
      width: 70,
      hideable: true,
      hide: true,
      renderCell: ({ value, row }: any) => {
        return (
          <div
            onDoubleClick={() => {
              if (row && row.id) {
                setKrId(row.id);
                setShowAddEvalModal(true); // باز کردن مدال
              }
            }}
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Box>
              {value.length > 10 ? (
                <Tooltip sx={{ fontSize: "1.5rem !important" }} title={value}>
                  <MailOutlineIcon sx={{ fontSize: "20px" }} />
                </Tooltip>
              ) : (
                <Typography sx={{ fontSize: "12px" }}>
                  {value < 0 ? `${Math.abs(value)} -` : value}
                </Typography>
              )}
            </Box>
          </div>
        );
      },
    },    
    // {
    //   field: "threeTenthsValue",
    //   align: "center",
    //   headerName: "30%",
    //   headerAlign: "center",
    //   sortable: false,
    //   width: 70,
    //   hideable: true,
    //   hide: true,
    //   renderCell: ({ value, row }: any) => {
    //     return (
    //       <div
    //         onDoubleClick={() => {
    //           if (row && row.id) {
    //             setKrId(row.id);
    //             setShowAddEvalModal(true); // باز کردن مدال
    //           }
    //         }}
    //         style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}
    //       >
    //         <Box>
    //           {value.length > 5 ? (
    //             <Tooltip sx={{ fontSize: "1.5rem !important" }} title={value}>
    //               {value}
    //             </Tooltip>
    //           ) : (
    //             <Typography sx={{ fontSize: "12px" }}>
    //               {value < 0 ? `${Math.abs(value)} -` : value}
    //             </Typography>
    //           )}
    //         </Box>
    //       </div>
    //     );
    //   },
    // },
    {
      field: "threeTenthsValue",
      align: "center",
      headerName: "30%",
      headerAlign: "center",
      sortable: false,
      width: 70,
      hideable: true,
      hide: true,
      renderCell: ({ value, row }: any) => {
        return (
          <div
            onDoubleClick={() => {
              if (row && row.id) {
                setKrId(row.id);
                setShowAddEvalModal(true); // باز کردن مدال
              }
            }}
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Box>
              {value.length > 10 ? (
                <Tooltip sx={{ fontSize: "1.5rem !important" }} title={value}>
                  <MailOutlineIcon sx={{ fontSize: "20px" }} />
                </Tooltip>
              ) : (
                <Typography sx={{ fontSize: "12px" }}>
                  {value < 0 ? `${Math.abs(value)} -` : value}
                </Typography>
              )}
            </Box>
          </div>
        );
      },
    },    
    // {
    //   field: "sevenTenthsValue",
    //   align: "center",
    //   headerName: "70%",
    //   headerAlign: "center",
    //   sortable: false,
    //   width: 70,
    //   hideable: true,
    //   hide: true,
    //   renderCell: ({ value, row }: any) => {
    //     return (
    //       <div
    //         onDoubleClick={() => {
    //           if (row && row.id) {
    //             setKrId(row.id);
    //             setShowAddEvalModal(true); // باز کردن مدال
    //           }
    //         }}
    //       >
    //         <Box>
    //           {value.length > 5 ? (
    //             <Tooltip sx={{ fontSize: "1.5rem !important" }} title={value}>
    //               {value}
    //             </Tooltip>
    //           ) : (
    //             <Typography textAlign={"center"} sx={{ fontSize: "12px" }}>
    //               {value < 0 ? `${Math.abs(value)} -` : value}
    //             </Typography>
    //           )}
    //         </Box>
    //       </div>
    //     );
    //   },
    // },
    {
      field: "sevenTenthsValue",
      align: "center",
      headerName: "70%",
      headerAlign: "center",
      sortable: false,
      width: 70,
      hideable: true,
      hide: true,
      renderCell: ({ value, row }: any) => {
        return (
          <div
            onDoubleClick={() => {
              if (row && row.id) {
                setKrId(row.id);
                setShowAddEvalModal(true); // باز کردن مدال
              }
            }}
          >
            <Box>
              {value.length > 10 ? (
                <Tooltip sx={{ fontSize: "1.5rem !important" }} title={value}>
                  <MailOutlineIcon sx={{ fontSize: "20px" }} />
                </Tooltip>
              ) : (
                <Typography textAlign={"center"} sx={{ fontSize: "12px" }}>
                  {value < 0 ? `${Math.abs(value)} -` : value}
                </Typography>
              )}
            </Box>
          </div>
        );
      },
    },    
    // {
    //   field: "oneValue",
    //   align: "center",
    //   headerName: "100%",
    //   headerAlign: "center",
    //   sortable: false,
    //   width: 80,
    //   hideable: true,
    //   hide: true,
    //   renderCell: ({ value, row }: any) => {
    //     return (
    //       <div
    //         onDoubleClick={() => {
    //           if (row && row.id) {
    //             setKrId(row.id);
    //             setShowAddEvalModal(true); // باز کردن مدال
    //           }
    //         }}
    //         style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}
    //       >
    //         <Box>
    //           {value.length > 5 ? (
    //             <Tooltip sx={{ fontSize: "1.5rem !important" }} title={value}>
    //               {value}
    //             </Tooltip>
    //           ) : (
    //             <Typography sx={{ fontSize: "12px" }}>
    //               {value < 0 ? `${Math.abs(value)} -` : value}
    //             </Typography>
    //           )}
    //         </Box>
    //       </div>
    //     );
    //   },
    // },
    {
      field: "oneValue",
      align: "center",
      headerName: "100%",
      headerAlign: "center",
      sortable: false,
      width: 80,
      hideable: true,
      hide: true,
      renderCell: ({ value, row }: any) => {
        return (
          <div
            onDoubleClick={() => {
              if (row && row.id) {
                setKrId(row.id);
                setShowAddEvalModal(true); // باز کردن مدال
              }
            }}
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Box>
              {value.length > 10 ? (
                <Tooltip sx={{ fontSize: "1.5rem !important" }} title={value}>
                  <MailOutlineIcon sx={{ fontSize: "20px" }} />
                </Tooltip>
              ) : (
                <Typography sx={{ fontSize: "12px" }}>
                  {value < 0 ? `${Math.abs(value)} -` : value}
                </Typography>
              )}
            </Box>
          </div>
        );
      },
    },    
    {
      // name:'startDate',
      field: "startDate",
      headerName: "تاریخ شروع",
      align: "center",
      sortable: false,
      headerAlign: "center",
      width: 100,
      renderCell: ({ value, row }: any) => {
        return (
          <div
            onDoubleClick={() => {
              if (row && row.id) {
                setKrId(row.id);
                setShowAddEvalModal(true); // باز کردن مدال
              }
            }}
            style={{ width: "100%", display: "flex", justifyContent:"center", alignItems:"center" }} 
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              {value.length > 40 ? (
                <Tooltip sx={{ fontSize: "1.5rem !important" }} title={value}>
                  {value}
                </Tooltip>
              ) : (
                <Typography sx={{ fontSize: "12px" }}>{value}</Typography>
              )}
            </Box>
          </div>
        );
      },
    },
    {
      // name:'startDate',
      field: "forceEndDate",
      headerName: "حداکثر تاریخ انجام",
      align: "center",
      sortable: false,
      headerAlign: "center",
      width: 100,
      renderCell: ({ value, row }: any) => {
        return (
          <div
            onDoubleClick={() => {
              if (row && row.id) {
                setKrId(row.id);
                setShowAddEvalModal(true); // باز کردن مدال
              }
            }}
            style={{ width: "100%", display: "flex", justifyContent:"center", alignItems:"center" }} 
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              {value.length > 40 ? (
                <Tooltip sx={{ fontSize: "1.5rem !important" }} title={value}>
                  {value}
                </Tooltip>
              ) : (
                <Typography sx={{ fontSize: "12px" }}>{value}</Typography>
              )}
            </Box>
          </div>
        );
      },
    },
    {
      field: "oldValue",
      headerName: "مقدار قبلی",
      align: "center",
      sortable: false,
      headerAlign: "center",
      // width: 115,
      width: columnWidths.oldValue,
      renderHeader: (params:any) => (
        <div style={headerCellStyle}>
          {params.colDef.headerName}
          <div
            style={resizeHandleStyle}
            onMouseDown={(e) => handleMouseDown(e, 'oldValue')}
          />
        </div>
      ),
      renderCell: ({ value, row }: any) => {
        const formattedValue = typeof value === "string" ? value : value < 0 ? `${Math.abs(value)} -` : value;
    
        return (
          <div
            onDoubleClick={() => {
              if (row && row.id) {
                setKrId(row.id);
                setShowAddEvalModal(true); // باز کردن مدال
              }
            }}
            style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}
          >
            <Box>
              {formattedValue.length > 10 ? (
                <Tooltip sx={{ fontSize: "12px !important" }} title={formattedValue}>
                  <Typography fontSize={"12px"}>{formattedValue}</Typography>
                </Tooltip>
              ) : (
                <Typography sx={{ fontSize: "12px" }}>{formattedValue}</Typography>
              )}
            </Box>
          </div>
        );
      },
    },
    
    {
      field: "oldScore",
      headerName: "امتیاز قبلی",
      align: "center",
      sortable: false,
      headerAlign: "center",
      // width: 75,

      width: columnWidths.oldScore,
      renderHeader: (params:any) => (
        <div style={headerCellStyle}>
          {params.colDef.headerName}
          <div
            style={resizeHandleStyle}
            onMouseDown={(e) => handleMouseDown(e, 'oldScore')}
          />
        </div>
      ),      renderCell: (par: any, row : any) => {
        // console.log(par?.row?.score)
        let score: string = par?.row?.oldScore;
        // console.log(score);
        if (typeof score === "string" && score.includes("%")) {
          let pureNum = score.slice(0, score.length - 1);
          let intVal = +pureNum;
          let color = "";
          let fColor = "";
          switch (true) {
            case intVal >= 70:
              color = "#D5F7D4";
              fColor = "#125610";
              break;
            case intVal < 70 && intVal > 30:
              color = "#FFF8D0";
              fColor = "#6B6440";
              break;
            default:
              color = "#FFEEE5";
              fColor = "#993600";
              break;
          }
          return (
            <div
            onDoubleClick={() => {
              if (row && row.id) {
                setKrId(row.id);
                setShowAddEvalModal(true); // باز کردن مدال
              }
            }}
            style={{ width: "100%", display: "flex", justifyContent:"center", alignItems:"center" }} 
          >
            <Box
              m={3}
              borderRadius={2}
              width={"100%"}
              display={"flex"}
              justifyContent={"center"}
              alignItems={"center"}
              height={"65%"}
              bgcolor={color}
              my={1}
            >
              <Typography
                px={8}
                color={fColor}
                fontSize={"0.8rem"}
                fontWeight={400}
              >
                {intVal}
              </Typography>
            </Box>
            </div>
          );
        } else {
          return (
            <div
            onDoubleClick={() => {
              if (row && row.id) {
                setKrId(row.id);
                setShowAddEvalModal(true); // باز کردن مدال
              }
            }}
            style={{ width: "100%", display: "flex", justifyContent:"center", alignItems:"center" }} 
          >
            <Box>
              <Typography>{score}</Typography>
            </Box>
            </div>
          );
        }
      },
    },
    {
      field: "combinedValue",
      headerName: "مقدار جدید",
      align: "center",
      headerAlign: "center",
      sortable: false,
      width: columnWidths.combinedValue,
      renderHeader: (params:any) => (
        <div style={headerCellStyle}>
          {params.colDef.headerName}
          <div
            style={resizeHandleStyle}
            onMouseDown={(e) => handleMouseDown(e, 'combinedValue')}
          />
        </div>
      ),
      renderCell: ({ row }: any) => {
        const currentValue = row.currentValue;
        const revenueTwo = row.revenueTwo; 
        let formattedRevenueTwo = "";
        let isPositive: boolean | undefined;
        if (revenueTwo && revenueTwo.length > 2 && revenueTwo !== "محاسبه نشده") {
          const numericRevenue = parseFloat(revenueTwo.replace("-", "").replace("%", "")); // تبدیل رشته به عدد
          const roundedRevenue = Math.round(numericRevenue); // گرد کردن درصد به عدد صحیح
          formattedRevenueTwo = `${roundedRevenue}%`; // افزودن علامت درصد
          isPositive = !revenueTwo.includes("-"); // تشخیص مثبت یا منفی بودن
        }
        
        const formattedCurrentValue = typeof currentValue === "string"
          ? currentValue
          : currentValue < 0
            ? `${Math.abs(currentValue)} -`
            : currentValue;
    
        return (
          <div
            onDoubleClick={() => {
              if (row && row.id) {
                setKrId(row.id);
                setShowAddEvalModal(true); // باز کردن مدال
              }
            }}
            style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}
          >
            <Box display={"flex"} alignItems={"center"}>
            {isPositive !== undefined && (
                <div style={{ marginLeft: '4px' }}>
                  {isPositive ? (
                    <TrendingUpIcon color="secondary" />
                  ) : (
                    <TrendingDownIcon color="error" />
                  )}
                </div>
              )}
              <Typography fontSize={"12px"} fontWeight={800}>
                {formattedRevenueTwo && `(${formattedRevenueTwo})`}{" "}
                {formattedCurrentValue}
              </Typography>

            </Box>
          </div>
        );
      },
    },
    
    {
      field: "currentValue",
      headerName: "مقدار جدید (ستون قبلی)",
      align: "center",
      sortable: false,
      headerAlign: "center",
      width: 100,
      hideable: true,
      hide: true,
      renderCell: ({ value, row }: any) => {
        const formattedValue = typeof value === "string" ? value : value < 0 ? `${Math.abs(value)} -` : value;
    
        return (
          <div
            onDoubleClick={() => {
              if (row && row.id) {
                setKrId(row.id);
                setShowAddEvalModal(true); // باز کردن مدال
              }
            }}
            style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}
          >
            <Box>
              {formattedValue.length > 10 ? (
                <Tooltip sx={{ fontSize: "1.5rem !important" }} title={formattedValue}>
                  <Typography sx={{ fontSize: "12px" }}>{formattedValue}</Typography>
                </Tooltip>
              ) : (
                <Typography sx={{ fontSize: "12px" }}>{formattedValue}</Typography>
              )}
            </Box>
          </div>
        );
      },
    },
    {
      field: "combinedScore",
      headerName: "امتیاز جدید",
      align: "center",
      headerAlign: "center",
      sortable: false,
      width: columnWidths.combinedScore,
      renderHeader: (params: any) => (
        <div style={headerCellStyle}>
          {params.colDef.headerName}
          <div
            style={resizeHandleStyle}
            onMouseDown={(e) => handleMouseDown(e, "combinedScore")} // اضافه کردن قابلیت تغییر اندازه
          />
        </div>
      ),
      renderCell: ({ row }: any) => {
        const score = row.score;
        const revenue = row.revenue;
    
        let intVal = "";
        let color = "";
        let fColor = "";
    
        if (typeof score === "string" && score.includes("%")) {
          const pureNum = score.slice(0, score.length - 1);
          intVal = pureNum;
          const intScore = +pureNum;
          switch (true) {
            case intScore >= 70:
              color = "#D5F7D4";
              fColor = "#125610";
              break;
            case intScore < 70 && intScore > 30:
              color = "#FFF8D0";
              fColor = "#6B6440";
              break;
            default:
              color = "#FFEEE5";
              fColor = "#993600";
              break;
          }
        } else {
          intVal = score;
        }
        let revenueDisplay = "";
let isPositive: boolean | undefined;

if (revenue && revenue.length > 2 && revenue !== "محاسبه نشده") {
  const numericRevenue = parseFloat(revenue.replace("-", "").replace("%", "")); // تبدیل رشته به عدد
  const roundedRevenue = Math.round(numericRevenue); // گرد کردن به عدد صحیح
  revenueDisplay = `${roundedRevenue}%`; // افزودن علامت درصد
  isPositive = !revenue.includes("-"); // تشخیص مثبت یا منفی بودن
}

    
        return (
          <div
            onDoubleClick={() => {
              if (row && row.id) {
                setKrId(row.id);
                setShowAddEvalModal(true);
              }
            }}
            style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}
          >
            <Box
              display={"flex"}
              alignItems={"center"}
              justifyContent={"center"}
              bgcolor={color}
              width={"100%"}
              height={"75%"}
              textAlign={"center"}
              px={1}
              borderRadius={2}
            >
              {isPositive !== undefined && (
                <div style={{ marginLeft: '4px' }}>
                  {isPositive ? (
                    <TrendingUpIcon color="secondary" />
                  ) : (
                    <TrendingDownIcon color="error" />
                  )}
                </div>
              )}
              <Typography fontSize={"12px"} color={fColor} fontWeight={800}>
                {revenueDisplay && `(${revenueDisplay})`} {" "}
                {intVal}
              </Typography>
            </Box>
          </div>
        );
      },
    },
    {
      field: "score",
      headerName: "امتیاز جدید (ستون قبلی)",
      align: "center",
      sortable: false,
      headerAlign: "center",
      width: 75,
      hideable: true,
      hide: true,
      renderCell: (par: any, row : any) => {
        // console.log(par?.row?.score)
        let score: string = par?.row?.score;
        // console.log(score);
        if (typeof score === "string" && score.includes("%")) {
          let pureNum = score.slice(0, score.length - 1);
          let intVal = +pureNum;
          let color = "";
          let fColor = "";
          switch (true) {
            case intVal >= 70:
              color = "#D5F7D4";
              fColor = "#125610";
              break;
            case intVal < 70 && intVal > 30:
              color = "#FFF8D0";
              fColor = "#6B6440";
              break;
            default:
              color = "#FFEEE5";
              fColor = "#993600";
              break;
          }
          return (
            <div
            onDoubleClick={() => {
              if (row && row.id) {
                setKrId(row.id);
                setShowAddEvalModal(true); // باز کردن مدال
              }
            }}
            style={{ width: "100%", display: "flex", justifyContent:"center", alignItems:"center" }} 
          >
            <Box
              m={3}
              borderRadius={2}
              width={"100%"}
              display={"flex"}
              justifyContent={"center"}
              alignItems={"center"}
              height={"65%"}
              bgcolor={color}
              my={1}
            >
              <Typography
                px={8}
                color={fColor}
                fontSize={"0.8rem"}
                fontWeight={800}
              >
                {intVal}
              </Typography>
            </Box>
            </div>
          );
        } else {
          return (
            <div
            onDoubleClick={() => {
              if (row && row.id) {
                setKrId(row.id);
                setShowAddEvalModal(true); // باز کردن مدال
              }
            }}
            style={{ width: "100%", display: "flex", justifyContent:"center", alignItems:"center" }} 
          >
            <Box>
              <Typography fontWeight={800}>{score}</Typography>
            </Box>
            </div>
          );
        }
      },
    },
    {
      field: "difference",
      headerName: "تفاوت",
      align: "center",
      sortable: false,
      headerAlign: "center",
      width: columnWidths.difference,
      renderHeader: (params: any) => (
        <div style={headerCellStyle}>
          {params.colDef.headerName}
          <div
            style={resizeHandleStyle}
            onMouseDown={(e) => handleMouseDown(e, "difference")} // اضافه کردن قابلیت تغییر اندازه
          />
        </div>
      ),
      renderCell: (param: any, row: any) => {
        let difference: string = param?.row?.difference;
        let postive;
    
        if (difference && difference !== '0' && difference !== "-") {
          postive = difference.includes("-");
          return (
            <div
              onDoubleClick={() => {
                if (row && row.id) {
                  setKrId(row.id);
                  setShowAddEvalModal(true); // باز کردن مدال
                }
              }}
              style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }} 
            >
              <Box
                display={"flex"}
                alignItems={"center"}
                justifyContent={"center"}
                columnGap={1}
              >
                <Typography fontSize={"0.6rem"}>
                  {difference.replace("-", "")}
                </Typography>
    
                {!postive ? (
                  <TrendingUpIcon color="secondary" />
                ) : (
                  <TrendingDownIcon color="error" />
                )}
              </Box>
            </div>
          );
        } else if (difference && difference !== '0') {
          return (
            <div
              onDoubleClick={() => {
                if (row && row.id) {
                  setKrId(row.id);
                  setShowAddEvalModal(true); // باز کردن مدال
                }
              }}
              style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }} 
            >
              <Box
                display={"flex"}
                alignItems={"center"}
                justifyContent={"center"}
                columnGap={1}
              >
                <Typography fontSize={"0.6rem"}>{difference}</Typography>
              </Box>
            </div>
          );
        } else {
          return (
            <div
              onDoubleClick={() => {
                if (row && row.id) {
                  setKrId(row.id);
                  setShowAddEvalModal(true); // باز کردن مدال
                }
              }}
              style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }} 
            >
              <Typography fontSize={"0.6rem"}>
                {difference}
              </Typography>
            </div>
          );
        }
      },
    },
    
    {
      field: "revenue",
      headerName: "عملکرد امتیاز (ستون قبلی)",
      align: "center",
      headerAlign: "center",
      sortable: false,
      minWidth: 100,
      hideable: true,
      hide: true,
      fontsize: "14px",
      renderCell: (param: any, row : any) => {
        let revenue: string = param?.row?.revenue;
        let postive;
        if (revenue && revenue.length > 2 && revenue !== "محاسبه نشده") {
          postive = revenue.includes("-");
          return (
            <div
            onDoubleClick={() => {
              if (row && row.id) {
                setKrId(row.id);
                setShowAddEvalModal(true); // باز کردن مدال
              }
            }}
            style={{ width: "100%", display: "flex", justifyContent:"center", alignItems:"center" }} 
          >
            <Box
              display={"flex"}
              alignItems={"center"}
              justifyContent={"center"}
              columnGap={1}
            >
              <Typography fontSize={"0.6rem"}>
                {revenue.replace("-", "")}
              </Typography>

              {!postive ? (
                <TrendingUpIcon color="secondary" />
              ) : (
                <TrendingDownIcon color="error" />
              )}
            </Box>
            </div>
          );
        } else if (revenue && revenue.length <= 2 && revenue.includes("%")) {
          return (
            <div
            onDoubleClick={() => {
              if (row && row.id) {
                setKrId(row.id);
                setShowAddEvalModal(true); // باز کردن مدال
              }
            }}
            style={{ width: "100%", display: "flex", justifyContent:"center", alignItems:"center" }} 
          >
            <Box
              display={"flex"}
              alignItems={"center"}
              justifyContent={"center"}
              columnGap={1}
            >
              <Typography fontSize={"0.6rem"}>{revenue}</Typography>
            </Box>
            </div>
          );
        } else {
          return (
            <div
            onDoubleClick={() => {
              if (row && row.id) {
                setKrId(row.id);
                setShowAddEvalModal(true); // باز کردن مدال
              }
            }}
            style={{ width: "100%", display: "flex", justifyContent:"center", alignItems:"center" }} 
          >
            <Typography fontSize={"0.6rem"} /*color={"red"}*/>
              {revenue}
            </Typography>
            </div>
          );
        }
      },
    },
    {
      field: "revenueTwo",
      headerName: "عملکرد واقعی (ستون قبلی)",
      align: "center",
      headerAlign: "center",
      sortable: false,
      minWidth: 100,
      hideable: true,
      hide: true,
      fontsize: "14px",
      renderCell: (param: any, row :any) => {
        let revenueTwo: string = param?.row?.revenueTwo;
        let postive;
        if (
          revenueTwo &&
          revenueTwo.length > 2 &&
          revenueTwo !== "محاسبه نشده"
        ) {
          postive = revenueTwo.includes("-");
          return (
            <div
            onDoubleClick={() => {
              if (row && row.id) {
                setKrId(row.id);
                setShowAddEvalModal(true); // باز کردن مدال
              }
            }}
            style={{ width: "100%", display: "flex", justifyContent:"center", alignItems:"center" }} 
          >
            <Box
              display={"flex"}
              alignItems={"center"}
              justifyContent={"center"}
              columnGap={1}
            >
              <Typography fontSize={"0.6rem"}>
                {revenueTwo.replace("-", "")}
              </Typography>

              {!postive ? (
                <TrendingUpIcon color="secondary" />
              ) : (
                <TrendingDownIcon color="error" />
              )}
            </Box>
            </div>
          );
        } else if (
          revenueTwo &&
          revenueTwo.length <= 2 &&
          revenueTwo.includes("%")
        ) {
          return (
            <div
            onDoubleClick={() => {
              if (row && row.id) {
                setKrId(row.id);
                setShowAddEvalModal(true); // باز کردن مدال
              }
            }}
            style={{ width: "100%", display: "flex", justifyContent:"center", alignItems:"center" }} 
          >
            <Box
              display={"flex"}
              alignItems={"center"}
              justifyContent={"center"}
              columnGap={1}
            >
              <Typography fontSize={"0.6rem"}>{revenueTwo}</Typography>
            </Box>
            </div>
          );
        } else {
          return (
            <div
            onDoubleClick={() => {
              if (row && row.id) {
                setKrId(row.id);
                setShowAddEvalModal(true); // باز کردن مدال
              }
            }}
            style={{ width: "100%", display: "flex", justifyContent:"center", alignItems:"center" }} 
          >
            <Typography fontSize={"0.6rem"} /*color={"red"}*/>
              {revenueTwo}
            </Typography>
            </div>
          );
        }
      },
    },
    {
      field: "oldState",
      headerName: "وضعیت قبلی",
      sortable: false,
      headerAlign: "center",
      align: "center",
      width: 105,
      hideable: true,
      hide: true,
      renderCell: ({ value, row }: any) => {
        return (
          <div
            onDoubleClick={() => {
              if (row && row.id) {
                setKrId(row.id);
                setShowAddEvalModal(true); // باز کردن مدال
              }
            }}
            style={{ width: "100%", display: "flex", justifyContent:"center", alignItems:"center" }} 
          >
          <Box
            m={3}
            borderRadius={2}
            width={"100%"}
            display={"flex"}
            justifyContent={"center"}
            alignItems={"center"}
            height={"75%"}
            bgcolor={
              value === "در مسیر مناسب"
                ? "#D5F7D4"
                : value === "نیازمند توجه"
                ? "#FFEBEF"
                : "#F0F1F2"
            }
          >
            <Typography
              fontSize={"10px"}
              px={8}
              color={
                value === "نیازمند توجه"
                  ? "#F95700"
                  : value === "خارج از مسیر مناسب"
                  ? "#CC0030"
                  : "black"
              }
            >
              {value}
            </Typography>
          </Box>
          </div>
        );
      },
    },
    {
      field: "currentState",
      headerName: "وضعیت فعلی",
      sortable: false,
      headerAlign: "center",
      align: "center",
      width: columnWidths.currentState,
      renderHeader: (params: any) => (
        <div
          style={{
            ...headerCellStyle,
            width: `${columnWidths.currentState}px`, // عرض هدر به اندازه کل ستون
          }}
        >
          {params.colDef.headerName}
          <div
            style={resizeHandleStyle}
            onMouseDown={(e) => handleMouseDown(e, "currentState")} // اضافه کردن قابلیت تغییر اندازه
          />
        </div>
      ),
      renderCell: ({ value, row }: any) => {
        return (
          <div
            onDoubleClick={() => {
              if (row && row.id) {
                setKrId(row.id);
                setShowAddEvalModal(true); // باز کردن مدال
              }
            }}
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Box
              m={3}
              borderRadius={2}
              width={"100%"}
              display={"flex"}
              justifyContent={"center"}
              alignItems={"center"}
              height={"75%"}
              bgcolor={
                value === "در مسیر مناسب"
                  ? "#D5F7D4"
                  : value === "نیازمند توجه"
                  ? "#FFEBEF"
                  : "#F0F1F2"
              }
            >
              <Typography
                fontSize={"10px"}
                px={8}
                color={
                  value === "نیازمند توجه"
                    ? "#F95700"
                    : value === "خارج از مسیر مناسب"
                    ? "#CC0030"
                    : "black"
                }
              >
                {value}
              </Typography>
            </Box>
          </div>
        );
      },
    },
    
    {
      field: "oldNextState",
      headerName: "پیش بینی قبلی",
      align: "center",
      sortable: false,
      headerAlign: "center",
      width: 80,
      hideable: true,
      hide: true,
      renderCell: (par: any) => {
        let value: string = par?.row?.oldNextState;
        switch (value) {
          case "انتظار داریم به نتیجه درست برسیم":
            return (
              <Box sx={{ width: "100%", textAlign: "center" }}>
                <img src={smil} width={"25px"} />
              </Box>
            );
            break;

          case "با ریسک عدم دستیابی مواجه هستیم اما تمام تلاش خود را خواهیم کرد":
            return (
              <Box sx={{ width: "100%", textAlign: "center" }}>
                <img src={meh} width={"25px"} />
              </Box>
            );
            break;
          case "اعتقادی نداریم به نتیجه برسیم مگر اینکه رویکرد جدیدی اتخاذ کنیم":
            return (
              <Box sx={{ width: "100%", textAlign: "center" }}>
                <img src={sad} width={"25px"} />
              </Box>
            );
            break;
          default:
            return null;
            break;
        }
      },
    },
    {
      field: "nextState",
      headerName: "وضعیت آتی",
      align: "center",
      sortable: false,
      headerAlign: "center",
      width: 80,
      hideable: true,
      hide: true,
      renderCell: (par: any) => {
        let value: string = par?.row?.nextState;
        switch (value) {
          case "انتظار داریم به نتیجه درست برسیم":
            return (
              <Box sx={{ width: "100%", textAlign: "center" }}>
                <img src={smil} width={"25px"} />
              </Box>
            );
            break;

          case "با ریسک عدم دستیابی مواجه هستیم اما تمام تلاش خود را خواهیم کرد":
            return (
              <Box sx={{ width: "100%", textAlign: "center" }}>
                <img src={meh} width={"25px"} />
              </Box>
            );
            break;
          case "اعتقادی نداریم به نتیجه برسیم مگر اینکه رویکرد جدیدی اتخاذ کنیم":
            return (
              <Box sx={{ width: "100%", textAlign: "center" }}>
                <img src={sad} width={"25px"} />
              </Box>
            );
            break;
          default:
            return null;
            break;
        }
      },
    },
    {
      field: "problems",
      headerName: "موانع",
      align: "center",
      headerAlign: "center",
      sortable: false,
      width: 60,
      hideable: true,
      hide: true,
      renderCell: ({ value , row}: any) => {
        if (typeof value === "string") {
          let length = value.length;
          return (
            <div
            onDoubleClick={() => {
              if (row && row.id) {
                setKrId(row.id);
                setShowAddEvalModal(true); // باز کردن مدال
              }
            }}
            style={{ width: "100%", display: "flex", justifyContent:"center", alignItems:"center" }} 
          >
            <Box>
              {value.length > 0 ? (
                <>
                  <Tooltip sx={{ fontSize: "1.5rem !important" }} title={value}>
                    <Typography textAlign={"left"} sx={{ fontSize: "12px" }}>
                      {length > 0 ? <MailOutlineIcon /> : <MailOutlineIcon />}
                    </Typography>
                  </Tooltip>
                </>
              ) : (
                <Typography textAlign={"left"} sx={{ fontSize: "12px" }}>
                  {value}
                </Typography>
              )}
            </Box>
            </div>
          );
        } else {
          return value;
        }
      },
    },
    {
      field: "description",
      headerName: "توضیحات",
      align: "center",
      headerAlign: "center",
      sortable: false,
      minWidth: 60,
      fontsize: "14px",
      renderCell: ({ value , row}: any) => {
        if (typeof value === "string") {
          let length = value.length;
          return (
            <div
            onDoubleClick={() => {
              if (row && row.id) {
                setKrId(row.id);
                setShowAddEvalModal(true); // باز کردن مدال
              }
            }}
          >
            <Box>
              {value.length > 0 ? (
                <>
                  <Tooltip sx={{ fontSize: "1.5rem !important" }} title={value}>
                    <Typography textAlign={"left"} sx={{ fontSize: "12px" }}>
                      {length > 0 ? <MailOutlineIcon /> : <MailOutlineIcon />}
                    </Typography>
                  </Tooltip>
                </>
              ) : (
                <Typography textAlign={"left"} sx={{ fontSize: "12px" }}>
                  {value}
                </Typography>
              )}
            </Box>
            </div>
          );
        } else {
          return value;
        }
      },
    },
    {
      field: "commentt",
      headerName: "نظرات",
      align: "center",
      headerAlign: "center",
      sortable: false,
      minWidth: 60,
      fontsize: "14px",
      renderCell: ( par : any) => {
        if(par !== undefined && par !== null){
        let idd: string = par?.row?.id;
        let namee: string = par?.row?.name;
        let commentCount: number = par?.row?.commentCount;
        return (
          <Box display={"flex"} justifyContent={"end"}>
          <CommentModal id={idd} name={namee} meetingId={meetingId} commentCount={commentCount}/>
          </Box>
      )
        }
      },
    },
  ];

  useEffect(() => {

    if (justMyKr) {
      setMyKeysResultsList();
      renderContents();
    }else{
      setKeysResultsList();
      renderContents();
    }
  }, [objectivee]);

  const setKeysResultsList = (): any => {
    let keyrs = objectivee?.keyResultCheckingMeetingQueryResultDto;
    const keyRTmp =
      keyrs &&
      keyrs.map((item: any) => ({
        ...item,
        oldValue: thousandSeparator(item.oldValue),
        oneValue: thousandSeparator(item.oneValue),
        sevenTenthsValue: thousandSeparator(item.sevenTenthsValue),
        threeTenthsValue: thousandSeparator(item.threeTenthsValue),
        startValue: thousandSeparator(item.startValue),
        currentValue: thousandSeparator(item.currentValue),
      }));
    setKeyR(keyRTmp);
  };

  const setMyKeysResultsList = (): any => {
    let keyrs = objectivee?.keyResultCheckingMeetingQueryResultDto;
    const keyRTmp =
      keyrs &&
      keyrs
        .filter((item: any) => item.responsibleId === personId)  
        .map((item: any) => ({
          ...item,
          oldValue: thousandSeparator(item.oldValue),
          oneValue: thousandSeparator(item.oneValue),
          sevenTenthsValue: thousandSeparator(item.sevenTenthsValue),
          threeTenthsValue: thousandSeparator(item.threeTenthsValue),
          startValue: thousandSeparator(item.startValue),
          currentValue: thousandSeparator(item.currentValue),
        }));
    setKeyR(keyRTmp);
    
  };

  const renderContents = () => {
    if (!keyR && !getObjLoading) {
      return (
        <Box
          width={"50%"}
          mx={"auto"}
          display={"flex"}
          flexDirection={"column"}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <EmptyDataIcon style={{ width: "80px", height: "80px" }} />

          <Typography mt={2} color={"blue"} textAlign={"center"}>
            برای نمایش نتایج کلیدی از جدول بالا یک هدف را انتخاب نمایید.
          </Typography>
        </Box>
      );
    } else {
      return (
        <Grid item xs={12}>
          <Grid container>
            <Box
              display={"flex"}
              flexDirection={"row"}
              justifyContent={"space-around"}
            >
              <Box  px={3} display={"flex"} flexDirection={"row-reverse"}>
                <Box display={"flex"} flexDirection={"row"}>
                  <Typography  sx={{
    fontSize: { xs: "11Px", sm: "13px" } // در موبایل سایز کوچکتر، در وب سایز معمولی
  }} fontWeight={700}>
                    هدف: {objectivee?.name}
                  </Typography>
                </Box>
              </Box>
              <Box  px={3}>
              <Typography
  fontSize={"13px"}
  fontWeight={700}
  sx={{
    fontSize: { xs: "11Px", sm: "13px" } // در موبایل سایز کوچکتر، در وب سایز معمولی
  }}
>
  مسئول هدف: {objectivee?.responsibleName}
</Typography>

              </Box>
            </Box>
          </Grid>
          <Grid item xs={12}>
            {!getObjLoading && (
              <DyDataGrid
                data={keyR || []}
                columns={keyResultColumn || []}
                initialOnRowClick={setKrRowData}
                hideFooter={true}
                setSelectionModel={setKrSelectionModel}
                selectionModel={krSelectionModel}
                initState={KRinitialStatee}
                additionalToolbar={true}
                setShowHistory={setHistoryModal}
                setShowAttachment={setShowAttachment}
                setSpecialId={setKrId}
                setShowInformation={setShowModal}
                setShowAddEvalModal={setShowAddEvalModal}
                setShoowCommitmentsModal={setShowActionsModal}
                setShoowCommitmentsModal1={setShowActionsModal1}
                initialMount={true}
                setPointSys={setPointingSystem}
                drName={"KRinitialState"}
                setRowSelectedData={setRowSelectedData}
              />
            )}
          </Grid>
        </Grid>
      );
    }
  };

  return (
    <>
      <Grid container sx={{ bgcolor: "#F9F9F9" }} style={{ width: "100%" }}>
        <Grid item xs={treeView ? 12 : 10}>
          <Box py={1} my={0.5} borderRadius={1} boxShadow={1} bgcolor={"white"}>
            <Grid container>
              <Grid item xs={12} md={3}>
                <Box
                  display={"flex"}
                  justifyContent={"center"}
                  alignItems={"center"}
                >
                  <Typography
                    fontWeight={600}
                    fontSize={"13px"}
                    variant="button"
                    px={1}
                  >
                    {teamInfo.isCompany ? "نام شرکت:" : "نام تیم:"}
                  </Typography>
                  <Typography fontWeight={600} fontSize={"13px"}>
                    {teamInfo?.name}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12} md={3}>
                <Box
                  display={"flex"}
                  justifyContent={"center"}
                  alignItems={"center"}
                >
                  <Typography
                    fontWeight={600}
                    fontSize={"13px"}
                    variant="button"
                    px={1}
                  >
                    {teamInfo.isCompany ? "مدیر شرکت:" : "مدیر تیم:"}
                  </Typography>
                  <Typography fontWeight={600} fontSize={"13px"}>
                    {teamInfo?.managerCompanyName}
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={12} md={3}>
                <Box
                  display={"flex"}
                  justifyContent={"center"}
                  alignItems={"center"}
                >
                  <Typography
                    fontWeight={600}
                    fontSize={"13px"}
                    variant="button"
                    px={1}
                  >{`تعداد اهداف ${
                    teamInfo.isCompany ? "شرکت:" : "تیم:"
                  }`}</Typography>
                  <Typography fontWeight={600} fontSize={"13px"}>
                    {teamInfo?.objectivesCount}
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={12} md={3}>
                <Box
                  display={"flex"}
                  justifyContent={"center"}
                  alignItems={"center"}
                >
                  <Typography
                    fontWeight={600}
                    fontSize={"13px"}
                    variant="button"
                    px={1}
                  >{`تعداد نتایج ${
                    teamInfo.isCompany ? "شرکت:" : "تیم:"
                  }`}</Typography>
                  <Typography fontWeight={600} fontSize={"13px"}>
                    {teamInfo?.keyResultsCount}
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Grid>

        {!treeView && (
          <Grid
            mx={"auto"}
            item
            xs={12}
            sm={1.7}
            display={"flex"}
            alignItems={"center"}
          >
            <Grid container borderRadius={2} boxShadow={1}>
              <Grid item xs={9} my={"auto"}>
                <TeamsNavigations />
              </Grid>
              <Grid item xs={3} py={1}>
                <IconButton
                  size="small"
                  onClick={() => {
                    dispatch(changeTreeViewStateR());
                  }}
                >
                  <AccountTreeIcon />
                </IconButton>
              </Grid>
            </Grid>
          </Grid>
        )}

        <Box width={"100%"} borderRadius={2} boxShadow={2} bgcolor={"white"}>
          <Grid item xs={12}>
            <Typography
              px={3}
              py={1}
              textAlign={"left"}
              fontSize={"16px"}
              color={"#00387C"}
              fontWeight={800}
            >
              لیست اهداف
            </Typography>
            {!getObjLoading && objectivies && objectivies.length > 0 && (
              <DyDataGridObj
                initialOnRowClick={setObjectivee}
                data={objectivies}
                columns={objectiveColumns || []}
                hideFooter={true}
                setRowSelectedData={setObjectiveSelectedData}
                objcSelectionModel={objcSelectionModel}
                setSelectionModel={setObjSelectionModel}
                selectionModel={objcSelectionModel}
                initState={ObjctivieInitialState}
                setShowAttachment={setShowAttachment1}
                initialMount={true}
                additionalToolbar={true}
                setSpecialId={setObjeId}
                drName={"ObjctivieInitialState"}
              />
            )}
          </Grid>
        </Box>

        <Box
          mt={0.5}
          width={"100%"}
          borderRadius={3}
          boxShadow={2}
          bgcolor={"white"}
        >
          <Grid item xs={12}>
            <Typography
              px={3}
              fontSize={"16px"}
              py={0.5}
              textAlign={"left"}
              variant="h6"
              color={"#00387C"}
              fontWeight={800}
            >
              لیست نتایج کلیدی
            </Typography>
          </Grid>

          <Grid item xs={12} >
          <Box py={1} px={3}>
              </Box>
            <Grid container>{renderContents()}</Grid>
          </Grid>
        </Box>
        {showModal && krRowData && (
          <ModalLyt
          width={isMobile ? '350px' : '600px'}  // در موبایل 350px و در سایر اندازه‌ها 600px
            title={"هدف: " + objectivee?.name}
            showModal={Boolean(showModal)}
            setShowModal={setShowModal}
          >
            <KrDetails
              data={krRowData}
            />
          </ModalLyt>
        )}

        {historyModal && (
          <ModalLyt
            width={isMobile ? '350px' : '900px'}  // در موبایل 350px و در سایر اندازه‌ها 600px
            title={"تاریخچه نتیجه کلیدی"}
            showModal={Boolean(historyModal)}
            setShowModal={setHistoryModal}
          >
            <KrHistoryModalContent
              setShowModal={setHistoryModal}
              krDetail={krRowData}
              objective={objectivee}
              meetingId={meetingId}
              priodId={priodId}
              krId={krId}
            />
          </ModalLyt>
        )}

        {showAttachment && (
          <ModalLyt
            width={isMobile ? '350px' : '900px'}  // در موبایل 350px و در سایر اندازه‌ها 600px
            title={"ضمیمه"}
            showModal={Boolean(showAttachment)}
            setShowModal={setShowAttachment}
          >
              <CreateAttachment
              cancelo={setShowAddEvalModal}
              objectiveManiInfo={objectiveManiInfo}
              krMainInfo={krMainInfo}
              meetingId={meetingId}
              setChangeImgData={handleImageChange}
              onClose={handleImageSelectorClose}
              objectiveId={objectivee?.id}
              kresultId={krId}
              onsucces={setShowAddEvalModal}
              setShowToastMessage={setShowToastMessage}
              setAddEvalAsyncData={setAddEvalAsyncData}
            />
          </ModalLyt>
        )}

        {showAttachment1 && (
          <ModalLyt
            width={isMobile ? '350px' : '900px'}  // در موبایل 350px و در سایر اندازه‌ها 600px
            title={"ضمیمه"}
            showModal={Boolean(showAttachment1)}
            setShowModal={setShowAttachment1}
          >
              <CreateAttachmentObj
              cancelo={setShowAddEvalModal}
              objectiveManiInfo={objectiveManiInfo}
              krMainInfo={krMainInfo}
              setChangeImgData={handleImageChange}
              onClose={handleImageSelectorClose}
              objectiveId={objectivee?.id}
              kresultId={objId}
              onsucces={setShowAddEvalModal}
              setShowToastMessage={setShowToastMessage}
              setAddEvalAsyncData={setAddEvalAsyncData}
            />
           
          </ModalLyt>
        )}

        {ShowActionsModal && (
          <ModalLyt
            width={isMobile ? '350px' : '1100px'}  // در موبایل 350px و در سایر اندازه‌ها 600px
            title={"تعهدات"}
            showModal={Boolean(ShowActionsModal)}
            setShowModal={setShowActionsModal}
          >
            <KrActions
              loadingFlag={KRHLoading}
              data={KrHistoryData}
              krDetail={krRowData}
              objective={objectivee}
              isBAU={false}
            />
          </ModalLyt>
        )}

        {ShowActionsModal1 && (
             <ModalLyt 
             showModal={Boolean(ShowActionsModal1)}
             setShowModal={setShowActionsModal1}
             width={isMobile ? '350px' : '1200px'} 
             title={'ثبت درخواست/ پیشنهاد همکاری'}
             >
              <CooperationRequest 
                krId={krId} 
                objectiveId={objectivee?.id}
                teamId={objectivee?.teamId} 
                periodId={priodId} /> 
            </ModalLyt>
        )}

        {showAddEvalModal && (
          <ModalLyt
          width={isMobile ? '350px' : '1300px'}  // در موبایل 350px و در سایر اندازه‌ها 600px
          title={"تعیین مقدار برای نتیجه کلیدی"}
            showModal={Boolean(showAddEvalModal)}
            setShowModal={setShowAddEvalModal}
          >
            <CreateKReval
              cancelo={setShowAddEvalModal}
              objectiveManiInfo={objectiveManiInfo}
              krMainInfo={krMainInfo}
              objectiveId={objectivee?.id}
              kresultId={krId}
              onsucces={setShowAddEvalModal}
              setShowToastMessage={setShowToastMessage}
              setAddEvalAsyncData={setAddEvalAsyncData}
            />
          </ModalLyt>
        )}

        {showToolbarModal && (
          <ModalLyt
            title={"نتیجه کلی"}
            showModal={Boolean(showToolbarModal)}
            setShowModal={setShowToolbarModal}
          >
          </ModalLyt>
        )}

        {SuccessState && (
          <LyBackdrop
            visible={SuccessState}
          >
            <Box>
              <CircularProgress color="inherit" />
            </Box>
          </LyBackdrop>
        )}

        {showToastMessage && (
          <DYToastMessage
            isSuccess={addEvalAsyncData?.isSuccess}
            message={addEvalAsyncData?.metaData.message}
            setShow={setShowToastMessage}
            show={showToastMessage}
          />
        )}

      </Grid>
    </>
  );
};

export default ObjectiveKeyResults;
